import { render, staticRenderFns } from "./JsonKeyValueEditor.vue?vue&type=template&id=afb454cc&scoped=true&"
import script from "./JsonKeyValueEditor.vue?vue&type=script&lang=js&"
export * from "./JsonKeyValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonKeyValueEditor.vue?vue&type=style&index=0&id=afb454cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb454cc",
  null
  
)

export default component.exports